function Card(props: {
  variant?: string;
  extra?: string;
  children?: JSX.Element | any[];
  [x: string]: any;
}) {
  const { variant, extra, children, ...rest } = props;
  return (
    <div
      className={`!z-5 relative flex flex-col rounded-2xl 
        bg-[#18181F]/80 backdrop-blur-xl
        border border-white/10
        shadow-lg shadow-black/20
        text-gray-100
        ${extra}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;

